import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { OpenLayerAnnotation } from 'src/app/components/openlayer/openlayer.component';

@Injectable({
  providedIn: 'root'
})
export class OpenlayerService {
  drawMode$ = new BehaviorSubject('None');
  deleteSelectedAnnot$ = new BehaviorSubject(null);
  currentAnnot$: BehaviorSubject<OpenLayerAnnotation> = new BehaviorSubject({})
  savedAnnot$: BehaviorSubject<OpenLayerAnnotation> = new BehaviorSubject({})
  allSavedAnnot$ = new BehaviorSubject([]);
  drawingColor$ = new BehaviorSubject(null);
  
  constructor() { }

  set appendOneAllSavedAnnot(annot) {
    const prev = this.allSavedAnnot$.getValue()
    prev.push(annot)
    this.allSavedAnnot$.next(prev)
  }

  set updateOneAllSavedAnnot(annot) {
    const parsed = JSON.parse(annot)
    const prev = this.allSavedAnnot$.getValue().filter(annot => annot.id !== parsed.id);
    prev.push(annot)
    this.allSavedAnnot$.next(prev)
  }

  set appendManyAllSavedAnnot(annots) {
    const prev = this.allSavedAnnot$.getValue()
    this.allSavedAnnot$.next([...prev, ...annots])
  }

  set removeOneAllSavedAnnot(annot) {
    const prev = this.allSavedAnnot$.getValue()
    const curr = prev.filter(i => i !== annot);
    this.allSavedAnnot$.next(curr)
  }
}
